export const STRIPE_API_KEY = 'pk_live_piQTEiigCiB4So9ouc30EHAf'; // June 28, 2018
export const INDICATOR = 'yes'; 



// WEBPACK FOOTER //
// ./src/template/Modals/MyStoreCheckout/Stripe_key.js